import React from "react";
import "./Select.scss";
import Field from "../Field/Field";
import { ReactComponent as Icon } from "../../assets/media/arrow.svg";

/**
 * Select
 * @param {Object} props
 * @param {String} props.name Field name
 * @param {String} props.label Text label
 * @param {Array.<{ value, label }>} props.options Options
 * @param {String} [props.help] Help text
 * @returns {React.ReactElement}
 */
function Select({ name, label, options, help }) {
  return (
    <Field {...{ name, label, help }}>
      <div className="Select">
        <select className="Select__select" name={name} id={name}>
          {options.map((option) => (
            <option value={option.value} key={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <Icon className="Select__icon" />
      </div>
    </Field>
  );
}

export default Select;
